import { Injectable } from '@angular/core';
import { KPIsControllerService } from '@scip/api';
import { forkJoin, Observable } from 'rxjs';
import { OrganizationDashboardSubmissionCountDto, SubmissionsByYearDto } from '@scip/api';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class KpiService {
  constructor(private kpiApi: KPIsControllerService) {}

  submissionByOrganization(organizationId?: string, organizationName?: string): Observable<OrganizationDashboardSubmissionCountDto[]> {
    if (organizationId) {
      return forkJoin([
        this.kpiApi.countSubmissionsForOrganization('FULL', organizationId),
        this.kpiApi.countSubmissionsForOrganization('SIMPLIFIED', organizationId)
      ]).pipe(
        map(([fullCount, simplifiedCount]: [number, number]) => {
          return [
            {
              fullSubmissionCount: fullCount,
              organizationName: organizationName,
              simplifiedSubmissionCount: simplifiedCount
            }
          ];
        })
      );
    } else {
      return this.kpiApi.countSubmissionsForActiveOrganizations('FULL');
    }
  }

  submissionByYear(organizationId?: string): Observable<SubmissionsByYearDto[]> {
    if (organizationId) {
      return this.kpiApi.getSubmissionsByYearForOrganization(organizationId);
    } else {
      return this.kpiApi.getSubmissionsByYear();
    }
  }
}
